import React, { useContext, useState } from 'react';
import { Typography } from 'antd';
import { BsLightbulbFill } from 'react-icons/bs';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const LampStatusAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [loading, setLoading] = useState(false);

  const triggerLampAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: 'ON', threshold: 'OFF' }, credentials, ALERT_CATEGORY.LAMP_STATUS_ALERT)
      .then(() => { messageApi.success('Lamp alert triggered successfully'); onTriggered?.({ success: true, value: 'Headlamp ON' }); })
      .catch(() => { messageApi.error('Failed to trigger lamp status alert'); onTriggered?.({ success: false, value: 'Headlamp ON' }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={6}
      title="Lamp Status"
      icon={<BsLightbulbFill />}
      iconBg="#fefce8"
      iconColor="#ca8a04"
      onTrigger={triggerLampAlert}
      triggerLabel="Trigger Lamp Alert"
      loading={loading}
    >
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#fefce8',
          border: '1px solid #fde68a',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ca8a04', flexShrink: 0 }} />
        <Text style={{ fontSize: 12, color: '#92400e', fontWeight: 500 }}>
          Triggered when the headlamp is left ON
        </Text>
      </div>
    </AlertCard>
  );
};

export default LampStatusAlert;
